import { TCategorizedDataResponseSerie } from "@/components/ui/chart/types/categorized-chart-series.type";
import { ICategorizedSerieAdapter } from "@/utils/chart/adapters/types/categorized-chart-adapter.type";
import { ICommonSeriesAdapterOptions } from "@/utils/chart/adapters/types/common-adapter.type";
import { EPrefixSymbol, getValueByPrefix } from "@/utils/translation-utils";

export interface IColumnGradientColors {
  firstStop: string;
  secondStop: string;
}

interface IColumnSeriesAdapterOptions extends ICommonSeriesAdapterOptions {
  colorGradient: IColumnGradientColors;
  prefixSymbol: EPrefixSymbol;
  accessibilityDescription: string;
}

export function ColumnSeriesAdapter<KIND extends string>(
  opts: Partial<IColumnSeriesAdapterOptions> = {},
): ICategorizedSerieAdapter<KIND> {
  return {
    adapt(
      data: TCategorizedDataResponseSerie<KIND>,
      yAxisOpts?: Array<Highcharts.YAxisOptions>,
    ): Array<Highcharts.SeriesOptionsType> {
      const columnItems = data.value.map((item) => [
        item.name,
        typeof item.value === "number" ? getValueByPrefix(item.value, opts.prefixSymbol) : null,
      ]);
      const unit = data.unit;

      const results: Array<Highcharts.SeriesOptionsType> = [];

      results.push({
        id: data.kind,
        name: opts.name ?? data.kind,
        data: columnItems,
        type: "column",
        color: opts.colorGradient
          ? {
              linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
              stops: [
                [0, opts.colorGradient.firstStop],
                [1, opts.colorGradient.secondStop],
              ],
            }
          : undefined,
        yAxis: yAxisOpts?.findIndex((YAxisOpt) => YAxisOpt.id == unit),
        accessibility: {
          description: opts.accessibilityDescription,
        },
      });

      return results;
    },
  };
}
